import React from 'react';
import { Activity, AlertCircle, CheckCircle } from 'lucide-react';

export default function Rheuma() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="rheuma" className="rheuma-section">
      <div className="rheuma-container">
        
        <div className="rheuma-header">
          <div className="rheuma-badge">
            <div className="rheuma-icon-circle">
              <Activity color="white" size={16} />
            </div>
            Spezialisierung Rheuma
          </div>
          <h2 className="rheuma-title">Rheuma-Behandlung</h2>
        </div>
        <div className="rheuma-content-wrapper">
          <div className="rheuma-main-card">
            <h3 className="rheuma-question">
              <div className="rheuma-question-icon">
                <AlertCircle color="white" size={28} />
              </div>
              Was ist Rheuma?
            </h3>
            
            <p className="rheuma-text">
              Rheuma ist ein Sammelbegriff für eine Vielzahl verschiedener Erkrankungen. 
              Rheumatische Krankheiten können in allen Altersstufen, sozialen Schichten und 
              Berufsgruppen vorkommen. Durch chronisch entzündliche Prozesse an den Gelenken 
              kann es ohne gezielte Therapiemaßnahmen zu frühzeitigen Zerstörungen der Gelenke kommen.
            </p>
            
            <p className="rheuma-text">
              Um häufigen Krankenständen und vorzeitiger Berufsunfähigkeit vorzubeugen, ist daher 
              eine rasche Diagnosestellung und zielgerichtete Therapie von entscheidender Bedeutung. 
              Durch bessere Kenntnisse über Krankheitsentstehung und Verlauf konnten in den letzten 
              Jahren wirkungsvolle Medikamente entwickelt werden.
            </p>
            
            <p className="rheuma-text">
              Durch eine adäquate medikamentöse und nicht-medikamentöse (Physiotherapie, Ergotherapie) 
              Behandlung können neben einer Linderung der Beschwerden auch Zerstörungen oder 
              Funktionseinschränkungen der Gelenke verhindert werden.
            </p>

            <div className="rheuma-cta">
              <button
                onClick={() => scrollToSection('kontakt')}
                className="btn-rheuma"
              >
                Termin vereinbaren
                <CheckCircle size={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}